import { useCallback, useState } from 'react';

export const useReviewQueue = <T extends { id: string } | undefined>() => {
  const [items, setItems] = useState<T[]>([]);
  const [rawIndex, setCurrentIndex] = useState(0);
  const currentIndex = Math.min(rawIndex, Math.max(items.length - 1, 0));

  const removeById = useCallback(
    (id: string) => setItems((previous) => previous.filter((item) => item?.id !== id)),
    []
  );

  return { items, setItems, currentIndex, setCurrentIndex, removeById };
};
